import { EventPageType } from '@graphql/generated';

export const mockCustomPageDataFoo = {
  id: 'b2ec325a-e5c6-5e3f-8d97-6651058b7990',
  type: EventPageType.custom,
  pageSlug: 'foo',
  pageTitle: 'Accommodations',
  subTitle: 'We hope we can all stay together at the Majestic Elegance hotel. We also have a second room block if this fills up. Please reach out if you have any questions.',
  disabled: false,
  photo: null,
  mobilePhoto: null
};

export const mockCustomPageDataBar = {
  id: 'b2ec325a-e5c6-5e3f-8d97-6651058b7991',
  type: EventPageType.custom,
  pageSlug: 'bar',
  pageTitle: 'Bar custom page title',
  subTitle: 'We hope we can all stay together at the Majestic Elegance hotel. We also have a second room block if this fills up. Please reach out if you have any questions.',
  disabled: false,
  photo: {
    altTag: null,
    height: 2400,
    id: 'd57bb309-242e-5533-9fbb-42d5de8225f8',
    layout: { alignX: 'center', alignY: 'center' },
    transform: null,
    url: 'https://bliss-media-dev.withjoy.com/media/e91c76e5554b781e2dcc8bfcc32a0c4b568999cb4b30ca73f/LSbNlFZORhe5hepgPdUr_luca-micheli-RpvC77-exG0-unsplash.jpg',
    width: 3000
  },
  mobilePhoto: {
    altTag: null,
    height: 2400,
    id: 'd57bb309-242e-5533-9fbb-42d5de8225f8',
    layout: { alignX: 'center', alignY: 'center' },
    transform: null,
    url: 'https://bliss-media-dev.withjoy.com/media/e91c76e5554b781e2dcc8bfcc32a0c4b568999cb4b30ca73f/LSbNlFZORhe5hepgPdUr_luca-micheli-RpvC77-exG0-unsplash.jpg',
    width: 3000
  }
};

export const mockPageContainers = {
  pageContainers: [
    {
      id: `${mockCustomPageDataFoo.id}`,
      title: `${mockCustomPageDataFoo.pageTitle}`,
      slug: `${mockCustomPageDataFoo.pageSlug}`,
      sortOrder: 1,
      visibility: 'public',
      components: [
        {
          id: 'c51c72c1-5cd2-4d29-8df4-5db85653cd6a',
          text: 'Foo, of type text pageContainers.components[0]',
          type: 'text',
          sortOrder: 1
        },
        {
          id: '0203859e-ef68-4ec6-add6-ac5f78662849',
          text: 'Foo, of type text pageContainers.components[1]',
          type: 'text',
          sortOrder: 2
        }
      ]
    },
    {
      id: `${mockCustomPageDataBar.id}`,
      title: `${mockCustomPageDataBar.pageTitle}`,
      slug: `${mockCustomPageDataBar.pageSlug}`,
      sortOrder: 1,
      visibility: 'public',
      components: [
        {
          id: 'c51c72c1-5cd2-4d29-8df4-5db85653cd6b',
          text: 'Bar, of type text pageContainers.components[0]',
          type: 'text',
          sortOrder: 1
        },
        {
          id: '0203859e-ef68-4ec6-add6-ac5f78662848',
          text: 'Bar, of type text pageContainers.components[1]',
          type: 'text',
          sortOrder: 2
        }
      ]
    }
  ]
};
